export const WALLS = [
	{ x: 0, y: 0 },
	{ x: 1, y: 0 },
	{ x: 2, y: 0 },
	{ x: 3, y: 0 },
	{ x: 4, y: 0 },
	{ x: 5, y: 0 },
	{ x: 6, y: 0 },
	{ x: 7, y: 0 },
	{ x: 8, y: 0 },
	{ x: 9, y: 0 },
	{ x: 10, y: 0 },
	{ x: 11, y: 0 },
	{ x: 12, y: 0 },
	{ x: 13, y: 0 },
	{ x: 14, y: 0 },
	{ x: 15, y: 0 },
	{ x: 16, y: 0 },

	{ x: 0, y: 1 },
	{ x: 1, y: 1 },
	{ x: 2, y: 1 },
	{ x: 3, y: 1 },
	{ x: 4, y: 1 },
	{ x: 5, y: 1 },
	{ x: 6, y: 1 },
	{ x: 7, y: 1 },
	{ x: 8, y: 1 },
	{ x: 9, y: 1 },
	{ x: 10, y: 1 },
	{ x: 11, y: 1 },
	{ x: 12, y: 1 },
	{ x: 13, y: 1 },
	{ x: 14, y: 1 },
	{ x: 15, y: 1 },
	{ x: 16, y: 1 },

	{ x: 0, y: 2 },
	{ x: 1, y: 2 },
	{ x: 2, y: 2 },
	{ x: 3, y: 2 },
	{ x: 8, y: 2 },
	{ x: 13, y: 2 },
	{ x: 14, y: 2 },
	{ x: 15, y: 2 },
	{ x: 16, y: 2 },

	{ x: 0, y: 3 },
	{ x: 1, y: 3 },
	{ x: 2, y: 3 },
	{ x: 3, y: 3 },
	{ x: 5, y: 3 },
	{ x: 6, y: 3 },
	{ x: 8, y: 3 },
	{ x: 10, y: 3 },
	{ x: 11, y: 3 },
	{ x: 13, y: 3 },
	{ x: 14, y: 3 },
	{ x: 15, y: 3 },
	{ x: 16, y: 3 },

	{ x: 0, y: 4 },
	{ x: 1, y: 4 },
	{ x: 2, y: 4 },
	{ x: 3, y: 4 },
	{ x: 5, y: 4 },
	{ x: 11, y: 4 },
	{ x: 13, y: 4 },
	{ x: 14, y: 4 },
	{ x: 15, y: 4 },
	{ x: 16, y: 4 },

	{ x: 0, y: 5 },
	{ x: 1, y: 5 },
	{ x: 2, y: 5 },
	{ x: 3, y: 5 },
	{ x: 7, y: 5 },
	{ x: 9, y: 5 },
	{ x: 13, y: 5 },
	{ x: 14, y: 5 },
	{ x: 15, y: 5 },
	{ x: 16, y: 5 },

	{ x: 0, y: 6 },
	{ x: 1, y: 6 },
	{ x: 2, y: 6 },
	{ x: 3, y: 6 },
	{ x: 4, y: 6 },
	{ x: 5, y: 6 },
	{ x: 7, y: 6 },
	{ x: 9, y: 6 },
	{ x: 11, y: 6 },
	{ x: 12, y: 6 },
	{ x: 13, y: 6 },
	{ x: 14, y: 6 },
	{ x: 15, y: 6 },
	{ x: 16, y: 6 },

	{ x: 0, y: 7 },
	{ x: 1, y: 7 },
	{ x: 2, y: 7 },
	{ x: 3, y: 7 },
	{ x: 7, y: 7 },
	{ x: 9, y: 7 },
	{ x: 13, y: 7 },
	{ x: 14, y: 7 },
	{ x: 15, y: 7 },
	{ x: 16, y: 7 },

	{ x: 0, y: 8 },
	{ x: 1, y: 8 },
	{ x: 2, y: 8 },
	{ x: 1, y: 8 },
	{ x: 2, y: 8 },
	{ x: 3, y: 8 },
	{ x: 5, y: 8 },
	{ x: 11, y: 8 },
	{ x: 13, y: 8 },
	{ x: 14, y: 8 },
	{ x: 15, y: 8 },
	{ x: 16, y: 8 },

	{ x: 0, y: 9 },
	{ x: 1, y: 9 },
	{ x: 5, y: 9 },
	{ x: 7, y: 9 },
	{ x: 8, y: 9 },
	{ x: 9, y: 9 },
	{ x: 11, y: 9 },
	{ x: 15, y: 9 },
	{ x: 16, y: 9 },

	{ x: 0, y: 10 },
	{ x: 1, y: 10 },
	{ x: 3, y: 10 },
	{ x: 5, y: 10 },
	{ x: 7, y: 10 },
	{ x: 9, y: 10 },
	{ x: 11, y: 10 },
	{ x: 13, y: 10 },
	{ x: 15, y: 10 },
	{ x: 16, y: 10 },

	{ x: 0, y: 11 },
	{ x: 1, y: 11 },
	{ x: 3, y: 11 },
	{ x: 5, y: 11 },
	{ x: 7, y: 11 },
	{ x: 9, y: 11 },
	{ x: 11, y: 11 },
	{ x: 13, y: 11 },
	{ x: 15, y: 11 },
	{ x: 16, y: 11 },

	{ x: 0, y: 12 },
	{ x: 1, y: 12 },
	{ x: 5, y: 12 },
	{ x: 7, y: 12 },
	{ x: 11, y: 12 },
	{ x: 15, y: 12 },
	{ x: 16, y: 12 },

	{ x: 0, y: 13 },
	{ x: 1, y: 13 },
	{ x: 3, y: 13 },
	{ x: 5, y: 13 },
	{ x: 7, y: 13 },
	{ x: 9, y: 13 },
	{ x: 11, y: 13 },
	{ x: 13, y: 13 },
	{ x: 15, y: 13 },
	{ x: 16, y: 13 },

	{ x: 0, y: 14 },
	{ x: 1, y: 14 },
	{ x: 3, y: 14 },
	{ x: 5, y: 14 },
	{ x: 7, y: 14 },
	{ x: 9, y: 14 },
	{ x: 11, y: 14 },
	{ x: 13, y: 14 },
	{ x: 15, y: 14 },
	{ x: 16, y: 14 },

	{ x: 0, y: 15 },
	{ x: 1, y: 15 },
	{ x: 5, y: 15 },
	{ x: 7, y: 15 },
	{ x: 8, y: 15 },
	{ x: 9, y: 15 },
	{ x: 11, y: 15 },
	{ x: 15, y: 15 },
	{ x: 16, y: 15 },

	{ x: 0, y: 16 },
	{ x: 1, y: 16 },
	{ x: 2, y: 16 },
	{ x: 3, y: 16 },
	{ x: 5, y: 16 },
	{ x: 11, y: 16 },
	{ x: 13, y: 16 },
	{ x: 14, y: 16 },
	{ x: 15, y: 16 },
	{ x: 16, y: 16 },

	{ x: 0, y: 17 },
	{ x: 1, y: 17 },
	{ x: 2, y: 17 },
	{ x: 3, y: 17 },
	{ x: 7, y: 17 },
	{ x: 9, y: 17 },
	{ x: 13, y: 17 },
	{ x: 14, y: 17 },
	{ x: 15, y: 17 },
	{ x: 16, y: 17 },

	{ x: 0, y: 18 },
	{ x: 1, y: 18 },
	{ x: 2, y: 18 },
	{ x: 3, y: 18 },
	{ x: 4, y: 18 },
	{ x: 5, y: 18 },
	{ x: 7, y: 18 },
	{ x: 9, y: 18 },
	{ x: 11, y: 18 },
	{ x: 12, y: 18 },
	{ x: 13, y: 18 },
	{ x: 14, y: 18 },
	{ x: 15, y: 18 },
	{ x: 16, y: 18 },

	{ x: 0, y: 19 },
	{ x: 1, y: 19 },
	{ x: 2, y: 19 },
	{ x: 3, y: 19 },
	{ x: 7, y: 19 },
	{ x: 9, y: 19 },
	// { x: 13, y: 19 }, exit
	{ x: 14, y: 19 },
	{ x: 15, y: 19 },
	{ x: 16, y: 19 },

	{ x: 0, y: 20 },
	{ x: 1, y: 20 },
	{ x: 2, y: 20 },
	{ x: 3, y: 20 },
	{ x: 5, y: 20 },
	{ x: 11, y: 20 },
	{ x: 13, y: 20 },
	{ x: 14, y: 20 },
	{ x: 15, y: 20 },
	{ x: 16, y: 20 },

	{ x: 0, y: 21 },
	{ x: 1, y: 21 },
	{ x: 2, y: 21 },
	{ x: 3, y: 21 },
	{ x: 5, y: 21 },
	{ x: 6, y: 21 },
	{ x: 8, y: 21 },
	{ x: 10, y: 21 },
	{ x: 11, y: 21 },
	{ x: 13, y: 21 },
	{ x: 14, y: 21 },
	{ x: 15, y: 21 },
	{ x: 16, y: 21 },

	{ x: 0, y: 22 },
	{ x: 1, y: 22 },
	{ x: 2, y: 22 },
	{ x: 3, y: 22 },
	{ x: 8, y: 22 },
	{ x: 13, y: 22 },
	{ x: 14, y: 22 },
	{ x: 15, y: 22 },
	{ x: 16, y: 22 },

	{ x: 0, y: 23 },
	{ x: 1, y: 23 },
	{ x: 2, y: 23 },
	{ x: 3, y: 23 },
	{ x: 4, y: 23 },
	{ x: 5, y: 23 },
	{ x: 6, y: 23 },
	{ x: 7, y: 23 },
	{ x: 8, y: 23 },
	{ x: 9, y: 23 },
	{ x: 10, y: 23 },
	{ x: 11, y: 23 },
	{ x: 12, y: 23 },
	{ x: 13, y: 23 },
	{ x: 14, y: 23 },
	{ x: 15, y: 23 },
	{ x: 16, y: 23 },

	// { x: 0, y: 24 },
	// { x: 1, y: 24 },
	// { x: 2, y: 24 },
	// { x: 3, y: 24 },
	// { x: 4, y: 24 },
	// { x: 5, y: 24 },
	// { x: 6, y: 24 },
	// { x: 7, y: 24 },
	// { x: 8, y: 24 },
	// { x: 9, y: 24 },
	// { x: 10, y: 24 },
	// { x: 11, y: 24 },
	// { x: 12, y: 24 },
	// { x: 13, y: 24 },
	// { x: 14, y: 24 },
	// { x: 15, y: 24 },
	// { x: 16, y: 24 },
];
